import React from 'react';
import { TimeWithTimeZone } from '@common/components/time-with-time-zone';
import { Colors } from 'works/legacy/lib/style-helper';

export const CommentBlock = ({
  comment,
}: {
  comment: {
    contentAsText: string;
    updatedAt: string;
    author: {
      name: string;
    };
  };
}) => (
  <>
    <div className="comment-block">
      <p className="text-heavy">&quot;{comment.contentAsText}&quot;</p>
      <footer>
        {`${comment.author.name}, `}
        <TimeWithTimeZone date={comment.updatedAt} variant="long_format" />
      </footer>
    </div>
    <style jsx>{`
      .comment-block footer {
        color: ${Colors.midnightLighter};
        font-style: italic;
      }

      .comment-block p {
        margin: 8px 0;
      }
    `}</style>
  </>
);
